import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Check localStorage for saved preference
    const saved = localStorage.getItem('darkMode');
    return saved === 'true';
  });

  useEffect(() => {
    // Save preference to localStorage
    localStorage.setItem('darkMode', isDarkMode);
    
    // Apply theme to document
    if (isDarkMode) {
      document.documentElement.classList.add('dark-theme');
    } else {
      document.documentElement.classList.remove('dark-theme');
    }
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  const theme = {
    isDarkMode,
    toggleTheme,
    colors: isDarkMode ? darkColors : lightColors
  };

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};

// Light theme colors
const lightColors = {
  primary: '#1890ff',
  background: '#ffffff',
  surface: '#f5f5f5',
  text: '#262626',
  textSecondary: '#8c8c8c',
  border: '#d9d9d9',
  shadow: 'rgba(0, 0, 0, 0.1)',
  success: '#52c41a',
  warning: '#faad14',
  error: '#ff4d4f'
};

// Dark theme colors
const darkColors = {
  primary: '#40a9ff',
  background: '#141414',
  surface: '#1f1f1f',
  text: '#ffffff',
  textSecondary: '#bfbfbf',
  border: '#434343',
  shadow: 'rgba(0, 0, 0, 0.3)',
  success: '#73d13d',
  warning: '#ffc53d',
  error: '#ff7875'
};